// extracted by mini-css-extract-plugin
module.exports = {"label":"index-shimmer_label__3kH8W","placeholderShimmer":"index-shimmer_placeholderShimmer__1deGW"};